import { makeHttpRequest } from "@/shared";

import { mapInventoryStatusesFromServer } from "./mappers/mapInventoryStatusesFromServer";

const DEFAULT_PER_PAGE = 100;
const DEFAULT_MAX_PAGES = 20;

async function fetchStatusesPage(page, perPage) {
    const response = (
        await makeHttpRequest({
            url: "/inventory/state",
            method: "GET",
            params: {
                page,
                per_page: perPage,
                sort_name: "updated_at",
                sort_direction: "DESC",
            },
        })
    ).data;

    const items = Array.isArray(response?.data) ? response.data : [];

    return mapInventoryStatusesFromServer(items);
}

export async function getAllInventoryStatuses({
    perPage = DEFAULT_PER_PAGE,
    maxPages = DEFAULT_MAX_PAGES,
} = {}) {
    let page = 1;
    const byId = new Map();

    while (page <= maxPages) {
        const items = await fetchStatusesPage(page, perPage);

        for (const it of items) byId.set(it.id, it);

        if (items.length !== perPage) break;

        page += 1;
    }

    return Array.from(byId.values());
}
